import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';
import { MdEdit } from "react-icons/md";
import { Box, Button, styled, Dialog, DialogTitle, DialogActions, IconButton, TextField } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { CandidateProAction } from "../../../Redux/action/CandidateProAction";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};
const ApplySkills = () => {
  const { userResult } = useSelector((state) => state.Auth);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState({
    skills: ""
  });

  const {
    skills
  } = data;

  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const userInfo = useSelector((state) => state.Profile.result);
  // userInfo ? alert("hi"):alert("byyy")
  // if(userInfo){

  let newdata = []

  if (userInfo?.skills) {
    const newdatauserInfo = userInfo?.skills.split(",")

    newdata.push(newdatauserInfo)

  }
  //    
  // }

  let userData = userInfo;

  useEffect(() => {
    if (userData) {
      setData({ ...userData });
    }
  }, [userData]);

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    setData({ ...data, [name]: value });
  };

  const candidateId = userResult?.userid;;


  const dispatch = useDispatch();
  const handleSubmit = (e) => {
    e.preventDefault();

    let content = {
      candidateId,
      skills
    };
    dispatch(CandidateProAction(content));
  };
  const location = useLocation();
  return (
    <>
      <div>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
        >
          <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
            Update Your Profile Details.
          </BootstrapDialogTitle>
          <form onSubmit={handleSubmit}>
            <Box
              sx={{
                width: 500,
                maxWidth: '100%',
              }}
            >
              <TextField fullWidth label="Skills" name="skills" value={skills} onChange={handleInputChange} />
            </Box>
            <DialogActions>
              <Button autoFocus type="submit">
                Save changes
              </Button>
            </DialogActions>
          </form>
        </BootstrapDialog>
      </div>
      <div className="apply-profile-card13">
        <div className='edit-button'>
          <div className='overview'>
            <span style={{ fontWeight: "bold" }}>Skills</span>
            {location.state === null ? <><span onClick={handleClickOpen}><MdEdit /></span></> : console.log("data")}
          </div>
        </div>
        <div className='key_hr'> <hr /></div>
        <div className="contact_info-body">
          <div className="contact_skill">
            <div className="">
              <p className="">Recruiters last searched & viewed</p>
            </div>
          </div>
        </div>
        {newdata && newdata.map((item, i) => {
          return (
            <>
              <div className='skills_main'>
                {/* <p>{item}</p> */}
                {item !== null && item !== "" ? <p className="skills">{item[0]}</p> : <p className="candidate_Warning_data">Please Fill Your Key Experience</p>}
                {item !== null && item !== "" ? <p className="skills">{item[1]}</p> : <p className="candidate_Warning_data">Please Fill Your Key Experience</p>}
              </div>
              <div className='skills_main'>
                {/* <p>{item}</p> */}
                {item !== null && item !== "" ? <p className="skills">{item[2]}</p> : <p className="candidate_Warning_data">Please Fill Your Key Experience</p>}
                {item !== null && item !== "" ? <p className="skills">{item[3]}</p> : <p className="candidate_Warning_data">Please Fill Your Key Experience</p>}

              </div>
            </>
          )
        })}

      </div></>
  )
}

export default ApplySkills